/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "components/ui/accordion";
import { ExceptionCreated } from "./accordion-create";
import { ExceptionUpdated } from "./accordion-updated";

export function AccordionException({
  data,
  typeRequest,
}: {
  data: any[] | string;
  typeRequest: "CREATE" | "UPDATE";
}) {
  const parsedData: any[] = typeof data === "string" ? JSON.parse(data) : data;

  if (!Array.isArray(parsedData) || parsedData.length === 0) return null;

  return (
    <AccordionItem value="exception">
      <AccordionTrigger>
        {typeRequest === "CREATE"
          ? "Registros Criados"
          : "Registros Atualizados"}
      </AccordionTrigger>
      <AccordionContent>
        {typeRequest === "CREATE" ? (
          <ExceptionCreated data={parsedData} />
        ) : (
          <ExceptionUpdated data={parsedData} />
        )}
      </AccordionContent>
    </AccordionItem>
  );
}
